import { ReadAppConfiguration } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

export const getAppConfiguration = async (): Promise<ReadAppConfiguration> => {
  return await tinctApi.appConfiguration.getAppConfiguration();
};

export const useGetAppConfiguration = (
  options?: Omit<UseQueryOptions<ReadAppConfiguration, ApiError>, 'queryKey'>,
) =>
  useQuery({
    queryKey: ['app-configuration'],
    queryFn: () => getAppConfiguration(),
    ...options,
  });
